import { HelpCircleFilledIcon } from '@approvalmax/ui';
import { Box, List, Text, Tooltip } from '@approvalmax/ui/src/components';
import { memo, useState } from 'react';

import { helpItems } from './HelpTooltip.constants';
import { messages } from './HelpTooltip.messages';

export const HelpTooltip = memo(() => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    return (
        <Tooltip
            placement='bottom'
            activator={<HelpCircleFilledIcon size={16} color={isTooltipOpen ? 'midnight70' : 'midnight60'} />}
            onOpen={setIsTooltipOpen}
            display='flex'
        >
            <>
                <Text font='body' fontSize='small'>
                    {messages.tooltipTitle}
                </Text>

                <Box spacing='0 0 0 16'>
                    <List listStyle='outside'>
                        {helpItems.map((item, index) => (
                            <List.Item key={index}>
                                <Text font='body' fontSize='small' as='span'>
                                    {item}
                                </Text>
                            </List.Item>
                        ))}
                    </List>
                </Box>
            </>
        </Tooltip>
    );
});

HelpTooltip.displayName = 'HelpTooltip';
